import React, { ReactNode } from 'react'
import { Box, Text } from '@mindfulchefuk/design-system'

export const RecipePageSection = ({
  title,
  children,
}: {
  children?: ReactNode
  title: string
}) => (
  <Box mt={32}>
    <Text variant="heading-xs" as="h2" mb={12}>
      {title}
    </Text>
    {children}
  </Box>
)
